import { createBrowserRouter } from "react-router-dom";
import Layout from "../layout";
import CarClassic from "../pages/car/detail/CarClassic";
// import CarClassicSlider from "../pages/car/detail/CarClassicSlider";
// import CarExpandSlider from "../pages/car/detail/CarExpandSlider";
// import CarLayout1 from "../pages/car/detail/CarLayout1";
// import CarLayout2 from "../pages/car/detail/CarLayout2";
// import CarModernSlider from "../pages/car/detail/CarModernSlider";
// import CarScrollspy from "../pages/car/detail/CarScrollspy";
// import CarSlider from "../pages/car/detail/CarSlider";
// import CarThumbnailSlider from "../pages/car/detail/CarThumbnailSlider";
// import CarVideo from "../pages/car/detail/CarVideo";
// import Car2Grid from "../pages/car/grid/Car2Grid";
// import Car2RightGrid from "../pages/car/grid/Car2RightGrid";
// import Car3Grid from "../pages/car/grid/Car3Grid";
// import Car3RightGrid from "../pages/car/grid/Car3RightGrid";
// import CarNoSidebar from "../pages/car/grid/CarNoSidebar";
import CarLeftList from "../pages/car/listing/CarLeftList";
// import CarRightList from "../pages/car/listing/CarRightList";
// import CarInfiniteScroll from "../pages/car/other/CarInfiniteScroll";
// import CarLeftDrawer from "../pages/car/other/CarLeftDrawer";
// import CarLoadMore from "../pages/car/other/CarLoadMore";
// import CarRightDrawer from "../pages/car/other/CarRightDrawer";
// import CarTopCategory from "../pages/car/other/CarTopCategory";
// import CarTopFilter from "../pages/car/other/CarTopFilter";
// import CarWithoutSlider from "../pages/car/other/CarWithoutSlider";
// import CarWishlist from "../pages/car/Wishlist";
import CarLoanCalculator from "../pages/car/other/CarLoanCalculator";

import CarDemo1 from "../pages/home/CarDemo1";
// import JobDetail1 from "../pages/job/detail/JobDetail1";
// import JobDetail2 from "../pages/job/detail/JobDetail2";
// import JobDetail3 from "../pages/job/detail/JobDetail3";
// import JobDetail4 from "../pages/job/detail/JobDetail4";
// import JobDetail5 from "../pages/job/detail/JobDetail5";
// import JobGridNoSidebar from "../pages/job/grid/JobGridNoSidebar";
// import JobGridProgress from "../pages/job/grid/JobGridProgress";
// import JobGridType2 from "../pages/job/grid/JobGridType2";
// import JobGridType3 from "../pages/job/grid/JobGridType3";
// import JobLeftSidebar from "../pages/job/grid/JobLeftSidebar";
// import JobRightSidebar from "../pages/job/grid/JobRightSidebar";
// import JobLeftList from "../pages/job/listing/JobLeftList";
// import JobListNoSidebar from "../pages/job/listing/JobListNoSidebar";
// import JobRightList from "../pages/job/listing/JobRightList";
// import JobAd from "../pages/job/other/JobAd";
// import JobBothSidebar from "../pages/job/other/JobBothSidebar";
// import JobFilter from "../pages/job/other/JobFilter";
// import JobFullList from "../pages/job/other/JobFullList";
// import JobInfiniteScroll from "../pages/job/other/JobInfiniteScroll";
// import JobLeftDrawer from "../pages/job/other/JobLeftDrawer";
// import JobListStyle2 from "../pages/job/other/JobListStyle2";
// import JobLoadMore from "../pages/job/other/JobLoadMore";
// import JobRightDrawer from "../pages/job/other/JobRightDrawer";
// import JobWishlist from "../pages/job/Wishlist";
// import BlogAudioLayout from "../pages/pages/blog/blogDetail/BlogAudioLayout";
// import BlogLeftClassic from "../pages/pages/blog/blogDetail/BlogLeftClassic";
// import BlogQuoteLayout from "../pages/pages/blog/blogDetail/BlogQuoteLayout";
// import BlogRightClassic from "../pages/pages/blog/blogDetail/BlogRightClassic";
// import BlogSliderLayout from "../pages/pages/blog/blogDetail/BlogSliderLayout";
// import BlogVideoLayout from "../pages/pages/blog/blogDetail/BlogVideoLayout";
// import Blog2Grid from "../pages/pages/blog/blogPage/Blog2Grid";
// import Blog2GridRight from "../pages/pages/blog/blogPage/Blog2GridRight";
// import Blog3Masonry from "../pages/pages/blog/blogPage/Blog3Masonry";
// import BlogInfiniteScroll from "../pages/pages/blog/blogPage/BlogInfiniteScroll";
// import BlogLayout1 from "../pages/pages/blog/blogPage/BlogLayout1";
// import BlogLeftList from "../pages/pages/blog/blogPage/BlogLeftList";
// import BlogLeftSidebar from "../pages/pages/blog/blogPage/BlogLeftSidebar";
// import BlogLoadMore from "../pages/pages/blog/blogPage/BlogLoadMore";
// import BlogNoSidebar from "../pages/pages/blog/blogPage/BlogNoSidebar";
// import BlogRightList from "../pages/pages/blog/blogPage/BlogRightList";
// import BlogRightSidebar from "../pages/pages/blog/blogPage/BlogRightSidebar";
// import BlogTitle from "../pages/pages/blog/blogPage/BlogTitle";
// import BlogToSlider from "../pages/pages/blog/blogPage/BlogToSlider";
import AboutUs1 from "../pages/pages/other/AboutUs1";
import AboutUs2 from "../pages/pages/other/AboutUs2";
import JPJ from "../pages/pages/other/JPJ";
// import Condition from "../pages/pages/other/Condition";
// import ContactUs1 from "../pages/pages/other/ContactUs1";
import Services1 from "../pages/pages/other/Services1";
import ContactUs2 from "../pages/pages/other/ContactUs2";
import ConsignWithUs from "../pages/pages/other/ConsignWithUs";
import OurJourney from "../pages/pages/other/OurJourney";
import ContactUs3 from "../pages/pages/other/ContactUs3";
import Error404 from "../pages/pages/other/Error404";
// import Faq from "../pages/pages/other/Faq";
// import Login1 from "../pages/pages/other/Login1";
// import Login2 from "../pages/pages/other/Login2";
// import Login3 from "../pages/pages/other/Login3";
// import Login4 from "../pages/pages/other/Login4";
// import Pricing from "../pages/pages/other/Pricing";
// import Privacy from "../pages/pages/other/Privacy";
// import Services from "../pages/pages/other/Services";
// import SignUp1 from "../pages/pages/other/SignUp1";
// import SignUp2 from "../pages/pages/other/SignUp2";
// import SignUp3 from "../pages/pages/other/SignUp3";
// import Team from "../pages/pages/other/Team";
// import Testimonial from "../pages/pages/other/Testimonial";
// import UserDashboard from "../pages/pages/other/UserDashboard";
// import PortfolioDetail1 from "../pages/pages/portfolio/detail/PortfolioDetail1";
// import PortfolioDetail2 from "../pages/pages/portfolio/detail/PortfolioDetail2";
// import Portfolio2Grid from "../pages/pages/portfolio/portfolioPage/Portfolio2Grid";
// import Portfolio3Grid from "../pages/pages/portfolio/portfolioPage/Portfolio3Grid";
// import Portfolio4Grid from "../pages/pages/portfolio/portfolioPage/Portfolio4Grid";
// import PortfolioBoxSlider from "../pages/pages/portfolio/portfolioPage/PortfolioBoxSlider";
// import PortfolioCreativeFull from "../pages/pages/portfolio/portfolioPage/PortfolioCreativeFull";
// import PortfolioGalleryIcon from "../pages/pages/portfolio/portfolioPage/PortfolioGalleryIcon";
// import PortfolioImageChange from "../pages/pages/portfolio/portfolioPage/PortfolioImageChange";
// import PortfolioModern from "../pages/pages/portfolio/portfolioPage/PortfolioModern";
// import PortfolioParallax from "../pages/pages/portfolio/portfolioPage/PortfolioParallax";
// import PortfolioTransform from "../pages/pages/portfolio/portfolioPage/PortfolioTransform";
// import PortfolioVerticalSlider from "../pages/pages/portfolio/portfolioPage/PortfolioVerticalSlider";
// import PortfolioVideoModal from "../pages/pages/portfolio/portfolioPage/PortfolioVideoModal";
// import PropertyAccordion from "../pages/property/detail/PropertyAccordion";
// import PropertyAnimatedIcon from "../pages/property/detail/PropertyAnimatedIcon";
// import PropertyClassic from "../pages/property/detail/PropertyClassic";
// import PropertyImageSlider from "../pages/property/detail/PropertyImageSlider";
// import PropertyScrollspy from "../pages/property/detail/PropertyScrollspy";
// import PropertySidebarLayout from "../pages/property/detail/PropertySidebarLayout";
// import PropertySticky from "../pages/property/detail/PropertySticky";
// import PropertyTab from "../pages/property/detail/PropertyTab";
// import PropertyThumbSlider from "../pages/property/detail/PropertyThumbSlider";
// import PropertyVideo from "../pages/property/detail/PropertyVideo";
// import Property2Grid from "../pages/property/grid/Property2Grid";
// import Property2RightGrid from "../pages/property/grid/Property2RightGrid";
// import Property3Grid from "../pages/property/grid/Property3Grid";
// import Property3RightGrid from "../pages/property/grid/Property3RightGrid";
// import Property4Grid from "../pages/property/grid/Property4Grid";
// import PropertyGridNoSidebar from "../pages/property/grid/PropertyGridNoSidebar";
// import PropertyLeftList from "../pages/property/listing/PropertyLeftList";
// import PropertyRightList from "../pages/property/listing/PropertyRightList";
// import PropertyThumbList from "../pages/property/listing/PropertyThumbList";
// import PropertyVideoList from "../pages/property/listing/PropertyVideoList";
// import PropertyWithoutSlider from "../pages/property/listing/PropertyWithoutSlider";
// import MapLeft from "../pages/property/map/MapLeft";
// import MapList from "../pages/property/map/MapList";
// import MapModal from "../pages/property/map/MapModal";
// import MapRight from "../pages/property/map/MapRight";
// import PropertyGridWithoutSlider from "../pages/property/other/PropertyGridWithoutSlider";
// import PropertyInfiniteScroll from "../pages/property/other/PropertyInfiniteScroll";
// import PropertyLeftDrawer from "../pages/property/other/PropertyLeftDrawer";
// import PropertyLoadMore from "../pages/property/other/PropertyLoadMore";
// import PropertyParallax from "../pages/property/other/PropertyParallax";
// import PropertyRightDrawer from "../pages/property/other/PropertyRightDrawer";
// import PropertyWishlist from "../pages/property/Wishlist";
import ComingSoon from "../pages/pages/other/ComingSoon";

import { routes } from "./routes";

const RouterProvider = createBrowserRouter(
  [
    {
      element: <Layout />,
      children: [
        { path: "*", element: <Error404 /> },

        //Home
        { path: routes.Home.CarDemo1, element: <CarDemo1 />, index: true },

        //Property-Grid
        // { path: routes.Property.Grid.Property2Grid, element: <Property2Grid /> },
        // { path: routes.Property.Grid.Property2RightGrid, element: <Property2RightGrid /> },
        // { path: routes.Property.Grid.Property3Grid, element: <Property3Grid /> },
        // { path: routes.Property.Grid.Property3RightGrid, element: <Property3RightGrid /> },
        // { path: routes.Property.Grid.Property4Grid, element: <Property4Grid /> },
        // { path: routes.Property.Grid.PropertyGridNoSidebar, element: <PropertyGridNoSidebar /> },

        //Property-Listing
        // { path: routes.Property.Listing.PropertyLeftList, element: <PropertyLeftList /> },
        // { path: routes.Property.Listing.PropertyRightList, element: <PropertyRightList /> },
        // { path: routes.Property.Listing.PropertyVideoList, element: <PropertyVideoList /> },
        // { path: routes.Property.Listing.PropertyThumbList, element: <PropertyThumbList /> },
        // { path: routes.Property.Listing.PropertyWithoutSlider, element: <PropertyWithoutSlider /> },

        //Property-Other
        // { path: routes.Property.Other.PropertyLeftDrawer, element: <PropertyLeftDrawer /> },
        // { path: routes.Property.Other.PropertyRightDrawer, element: <PropertyRightDrawer /> },
        // { path: routes.Property.Other.PropertyInfiniteScroll, element: <PropertyInfiniteScroll /> },
        // { path: routes.Property.Other.PropertyLoadMore, element: <PropertyLoadMore /> },
        // { path: routes.Property.Other.PropertyParallax, element: <PropertyParallax /> },
        // { path: routes.Property.Other.PropertyGridWithoutSlider, element: <PropertyGridWithoutSlider /> },

        //Property-Map
        // { path: routes.Property.Map.MapLeft, element: <MapLeft /> },
        // { path: routes.Property.Map.MapRight, element: <MapRight /> },
        // { path: routes.Property.Map.MapList, element: <MapList /> },
        // { path: routes.Property.Map.MapModal, element: <MapModal /> },

        //Property-Detail
        // { path: routes.Property.Detail.PropertyClassic, element: <PropertyClassic /> },
        // { path: routes.Property.Detail.PropertyScrollspy, element: <PropertyScrollspy /> },
        // { path: routes.Property.Detail.PropertyTab, element: <PropertyTab /> },
        // { path: routes.Property.Detail.PropertyAccordion, element: <PropertyAccordion /> },
        // { path: routes.Property.Detail.PropertyImageSlider, element: <PropertyImageSlider /> },
        // { path: routes.Property.Detail.PropertySticky, element: <PropertySticky /> },
        // { path: routes.Property.Detail.PropertySidebarLayout, element: <PropertySidebarLayout /> },
        // { path: routes.Property.Detail.PropertyVideo, element: <PropertyVideo /> },
        // { path: routes.Property.Detail.PropertyThumbSlider, element: <PropertyThumbSlider /> },
        // { path: routes.Property.Detail.PropertyAnimatedIcon, element: <PropertyAnimatedIcon /> },

        //Property-Wishlist
        // { path: routes.Property.PropertyWishlist, element: <PropertyWishlist /> },

        //Car-Grid
        // { path: routes.Car.Grid.Car2Grid, element: <Car2Grid /> },
        // { path: routes.Car.Grid.Car2RightGrid, element: <Car2RightGrid /> },
        // { path: routes.Car.Grid.Car3Grid, element: <Car3Grid /> },
        // { path: routes.Car.Grid.Car3RightGrid, element: <Car3RightGrid /> },
        // { path: routes.Car.Grid.CarNoSidebar, element: <CarNoSidebar /> },

        //Car-Listing
        { path: routes.Car.Listing.CarLeftList, element: <CarLeftList /> },
        // { path: routes.Car.Listing.CarRightList, element: <CarRightList /> },

        //Car-Other
        // { path: routes.Car.Other.CarLeftDrawer, element: <CarLeftDrawer /> },
        // { path: routes.Car.Other.CarRightDrawer, element: <CarRightDrawer /> },
        // { path: routes.Car.Other.CarInfiniteScroll, element: <CarInfiniteScroll /> },
        // { path: routes.Car.Other.CarLoadMore, element: <CarLoadMore /> },
        // { path: routes.Car.Other.CarTopCategory, element: <CarTopCategory /> },
        // { path: routes.Car.Other.CarTopFilter, element: <CarTopFilter /> },
        // { path: routes.Car.Other.CarWithoutSlider, element: <CarWithoutSlider /> },
        { path: routes.Car.Other.CarLoanCalculator, element: <CarLoanCalculator /> },

        //Car-Detail
        { path: routes.Car.Detail.CarClassic, element: <CarClassic /> },
        // { path: routes.Car.Detail.CarLayout1, element: <CarLayout1 /> },
        // { path: routes.Car.Detail.CarLayout2, element: <CarLayout2 /> },
        // { path: routes.Car.Detail.CarSlider, element: <CarSlider /> },
        // { path: routes.Car.Detail.CarExpandSlider, element: <CarExpandSlider /> },
        // { path: routes.Car.Detail.CarModernSlider, element: <CarModernSlider /> },
        // { path: routes.Car.Detail.CarScrollspy, element: <CarScrollspy /> },
        // { path: routes.Car.Detail.CarVideo, element: <CarVideo /> },
        // { path: routes.Car.Detail.CarClassicSlider, element: <CarClassicSlider /> },
        // { path: routes.Car.Detail.CarThumbnailSlider, element: <CarThumbnailSlider /> },

        //Car-Wishlist
        // { path: routes.Car.CarWishlist, element: <CarWishlist /> },

        //Job-Grid
        // { path: routes.Job.Grid.JobGridProgress, element: <JobGridProgress /> },
        // { path: routes.Job.Grid.JobGridType2, element: <JobGridType2 /> },
        // { path: routes.Job.Grid.JobGridType3, element: <JobGridType3 /> },
        // { path: routes.Job.Grid.JobLeftSidebar, element: <JobLeftSidebar /> },
        // { path: routes.Job.Grid.JobRightSidebar, element: <JobRightSidebar /> },
        // { path: routes.Job.Grid.JobGridNoSidebar, element: <JobGridNoSidebar /> },

        //Job-Listing
        // { path: routes.Job.Listing.JobLeftList, element: <JobLeftList /> },
        // { path: routes.Job.Listing.JobRightList, element: <JobRightList /> },
        // { path: routes.Job.Listing.JobListNoSidebar, element: <JobListNoSidebar /> },

        //Job-Other
        // { path: routes.Job.Other.JobLeftDrawer, element: <JobLeftDrawer /> },
        // { path: routes.Job.Other.JobRightDrawer, element: <JobRightDrawer /> },
        // { path: routes.Job.Other.JobInfiniteScroll, element: <JobInfiniteScroll /> },
        // { path: routes.Job.Other.JobLoadMore, element: <JobLoadMore /> },
        // { path: routes.Job.Other.JobAd, element: <JobAd /> },
        // { path: routes.Job.Other.JobFilter, element: <JobFilter /> },
        // { path: routes.Job.Other.JobFullList, element: <JobFullList /> },
        // { path: routes.Job.Other.JobBothSidebar, element: <JobBothSidebar /> },
        // { path: routes.Job.Other.JobListStyle2, element: <JobListStyle2 /> },

        //Job-Detail
        // { path: routes.Job.Detail.JobDetail1, element: <JobDetail1 /> },
        // { path: routes.Job.Detail.JobDetail2, element: <JobDetail2 /> },
        // { path: routes.Job.Detail.JobDetail3, element: <JobDetail3 /> },
        // { path: routes.Job.Detail.JobDetail4, element: <JobDetail4 /> },
        // { path: routes.Job.Detail.JobDetail5, element: <JobDetail5 /> },

        //Job-Wishlist
        // { path: routes.Job.JobWishlist, element: <JobWishlist /> },

        //Blog-Pages
        // { path: routes.Pages.Blog.BlogLeftSidebar, element: <BlogLeftSidebar /> },
        // { path: routes.Pages.Blog.BlogRightSidebar, element: <BlogRightSidebar /> },
        // { path: routes.Pages.Blog.Blog2Grid, element: <Blog2Grid /> },
        // { path: routes.Pages.Blog.Blog2GridRight, element: <Blog2GridRight /> },
        // { path: routes.Pages.Blog.BlogTitle, element: <BlogTitle /> },
        // { path: routes.Pages.Blog.BlogLayout1, element: <BlogLayout1 /> },
        // { path: routes.Pages.Blog.BlogNoSidebar, element: <BlogNoSidebar /> },
        // { path: routes.Pages.Blog.BlogToSlider, element: <BlogToSlider /> },
        // { path: routes.Pages.Blog.Blog3Masonry, element: <Blog3Masonry /> },
        // { path: routes.Pages.Blog.BlogLoadMore, element: <BlogLoadMore /> },
        // { path: routes.Pages.Blog.BlogLeftList, element: <BlogLeftList /> },
        // { path: routes.Pages.Blog.BlogRightList, element: <BlogRightList /> },
        // { path: routes.Pages.Blog.BlogInfiniteScroll, element: <BlogInfiniteScroll /> },

        //Blog-Detail
        // { path: routes.Pages.Blog.Detail.BlogLeftClassic, element: <BlogLeftClassic /> },
        // { path: routes.Pages.Blog.Detail.BlogRightClassic, element: <BlogRightClassic /> },
        // { path: routes.Pages.Blog.Detail.BlogVideoLayout, element: <BlogVideoLayout /> },
        // { path: routes.Pages.Blog.Detail.BlogAudioLayout, element: <BlogAudioLayout /> },
        // { path: routes.Pages.Blog.Detail.BlogSliderLayout, element: <BlogSliderLayout /> },
        // { path: routes.Pages.Blog.Detail.BlogQuoteLayout, element: <BlogQuoteLayout /> },

        //Portfolio-Page
        // { path: routes.Pages.Portfolio.Portfolio2Grid, element: <Portfolio2Grid /> },
        // { path: routes.Pages.Portfolio.Portfolio3Grid, element: <Portfolio3Grid /> },
        // { path: routes.Pages.Portfolio.Portfolio4Grid, element: <Portfolio4Grid /> },
        // { path: routes.Pages.Portfolio.PortfolioTransform, element: <PortfolioTransform /> },
        // { path: routes.Pages.Portfolio.PortfolioVideoModal, element: <PortfolioVideoModal /> },
        // { path: routes.Pages.Portfolio.PortfolioGalleryIcon, element: <PortfolioGalleryIcon /> },
        // { path: routes.Pages.Portfolio.PortfolioImageChange, element: <PortfolioImageChange /> },
        // { path: routes.Pages.Portfolio.PortfolioBoxSlider, element: <PortfolioBoxSlider /> },
        // { path: routes.Pages.Portfolio.PortfolioParallax, element: <PortfolioParallax /> },
        // { path: routes.Pages.Portfolio.PortfolioVerticalSlider, element: <PortfolioVerticalSlider /> },
        // { path: routes.Pages.Portfolio.PortfolioCreativeFull, element: <PortfolioCreativeFull /> },
        // { path: routes.Pages.Portfolio.PortfolioModern, element: <PortfolioModern /> },

        //Portfolio-Detail
        // { path: routes.Pages.Portfolio.Detail.PortfolioDetail1, element: <PortfolioDetail1 /> },
        // { path: routes.Pages.Portfolio.Detail.PortfolioDetail2, element: <PortfolioDetail2 /> },

        //Other-Pages
        { path: routes.Pages.Other.JPJ, element: <JPJ /> },
        { path: routes.Pages.Other.AboutUs1, element: <AboutUs1 /> },
        { path: routes.Pages.Other.AboutUs2, element: <AboutUs2 /> },
        // { path: routes.Pages.Other.ContactUs1, element: <ContactUs1 /> },
        { path: routes.Pages.Other.Services1, element: <Services1 /> },
        { path: routes.Pages.Other.ContactUs2, element: <ContactUs2 /> },
        { path: routes.Pages.Other.ConsignWithUs, element: <ConsignWithUs /> },
        { path: routes.Pages.Other.OurJourney, element: <OurJourney /> },
        { path: routes.Pages.Other.ContactUs3, element: <ContactUs3 /> },
        // { path: routes.Pages.Other.Services, element: <Services /> },
        // { path: routes.Pages.Other.Team, element: <Team /> },
        // { path: routes.Pages.Other.Pricing, element: <Pricing /> },
        // { path: routes.Pages.Other.Testimonial, element: <Testimonial /> },
        // { path: routes.Pages.Other.Faq, element: <Faq /> },
        // { path: routes.Pages.Other.UserDashboard, element: <UserDashboard /> },
        // { path: routes.Pages.Other.Privacy, element: <Privacy /> },
        // { path: routes.Pages.Other.Condition, element: <Condition /> },
        { path: routes.Pages.Other.Error404, element: <Error404 /> },
        { path: routes.Pages.Other.ComingSoon, element: <ComingSoon /> },
        // { path: routes.Pages.Other.Login1, element: <Login1 /> },
        // { path: routes.Pages.Other.Login2, element: <Login2 /> },
        // { path: routes.Pages.Other.Login3, element: <Login3 /> },
        // { path: routes.Pages.Other.Login4, element: <Login4 /> },
        // { path: routes.Pages.Other.SignUp1, element: <SignUp1 /> },
        // { path: routes.Pages.Other.SignUp2, element: <SignUp2 /> },
        // { path: routes.Pages.Other.SignUp3, element: <SignUp3 /> },
      ],
    },
  ],
  {
    basename: "/",
  }
);

export default RouterProvider;
